export default function OnlineStore() {
  return (
    <section className="min-h-screen bg-white px-6 py-28">
      <div className="mx-auto flex w-full max-w-4xl items-center justify-center">
        <div className="w-full max-w-2xl rounded-[2.5rem] border border-neutral-200 bg-gradient-to-b from-white to-neutral-50 px-8 py-14 text-center shadow-[0_25px_60px_-35px_rgba(0,0,0,0.25)] md:px-12">
          <p className="mb-6 inline-flex items-center rounded-full border border-pink-200 bg-pink-50 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-pink-500">
            Coming Soon
          </p>
          <h1 className="font-['Playfair_Display'] text-4xl text-neutral-900 md:text-5xl">
            Online Store
          </h1>
          <div className="mx-auto mt-6 h-[1px] w-14 bg-neutral-300" />
          <p className="mx-auto mt-7 max-w-xl text-[15px] leading-relaxed text-neutral-600">
            We are carefully curating a premium collection of event and branding essentials.
            Our store will be launching soon.
          </p>
        </div>
      </div>
    </section>
  );
}
